import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const promotionsRoute: InvariantJiraRoute = {
	name: 'marketplace-promotions',
	path: '/jira/marketplace/manage/promotions',
};
